import { makeStyles } from '@material-ui/styles';
import { Theme, darken } from '@material-ui/core/styles';
import { black, carmine, gainsboro, iron } from 'styles/abstract/variables';

export const makeProductPaperClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            marginBottom: theme.spacing(2),

            '&:last-child': {
                marginBottom: theme.spacing(6),

                [theme.breakpoints.down('sm')]: {
                    marginBottom: 0,
                },
            },
        },
    }),
    { index: 1 },
);

export const makeProductClasses = makeStyles(
    (theme: Theme) => ({
        cover: {
            marginRight: theme.spacing(2),
            maxWidth: '8rem',

            [theme.breakpoints.down('xs')]: {
                marginBottom: theme.spacing(2),
            },
        },
        errorPanel: {
            bottom: '-0.25rem',
            color: carmine,
            fontSize: '0.75rem',
            position: 'absolute',
            textAlign: 'center',
            width: '100%',
        },
        infoPanel: {
            alignItems: 'flex-start',
            display: 'flex',
            flex: 1,
            paddingRight: theme.spacing(2),

            [theme.breakpoints.down('sm')]: {
                paddingRight: theme.spacing(3),
            },

            [theme.breakpoints.down('xs')]: {
                alignItems: 'baseline',
                flexDirection: 'column',
            },
        },
        pricePanel: {
            alignItems: 'center',
            borderLeft: `0.0625rem solid ${gainsboro}`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: theme.spacing(0, 6, 0, 8),
            position: 'relative',

            [theme.breakpoints.down('sm')]: {
                borderLeft: 0,
                borderTop: `0.0625rem solid ${gainsboro}`,
                flexDirection: 'row-reverse',
                marginTop: theme.spacing(3),
                padding: theme.spacing(3, 0, 3, 0),
            },

            '& > span': {
                marginBottom: '1rem',
                fontSize: '1.75rem',
                fontWeight: 400,

                [theme.breakpoints.down('sm')]: {
                    marginBottom: 0,
                },
            },
        },
        productsList: {
            paddingLeft: theme.spacing(2.125),
        },
        remove: {
            color: black,
            background: iron,
            position: 'absolute',
            top: '1rem',
            right: 0,
            padding: theme.spacing(0.5, 1),
            transition: 'all 0.3s ease',

            '&:hover': {
                background: darken(iron, 0.1),
                cursor: 'pointer',
            },
        },
        wrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            minHeight: '14rem',
            position: 'relative',

            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
    }),
    { index: 1 },
);
